export const UPDATE_PRODUCT_REQUESTED = 'UPDATE_PRODUCT_REQUESTED';
export const UPDATE_PRODUCT_SUCCEEDED = 'UPDATE_PRODUCT_SUCCEEDED';

export const DELETE_PRODUCT_REQUESTED = 'DELETE_PRODUCT_REQUESTED';
export const DELETE_PRODUCT_SUCCEEDED = 'DELETE_PRODUCT_SUCCEEDED';

export const CLONE_PRODUCT_REQUESTED = 'CLONE_PRODUCT_REQUESTED';
export const CLONE_PRODUCT_SUCCEEDED = 'CLONE_PRODUCT_SUCCEEDED';

export const REPROCESS_IMAGE_REQUESTED = 'REPROCESS_IMAGE_REQUESTED';

export const ROTATE_IMAGE_REQUESTED = 'ROTATE_IMAGE_REQUESTED';
export const ROTATE_IMAGE_SUCCEEDED = 'ROTATE_IMAGE_SUCCEEDED';

export const UPDATE_PRODUCT_SOLD_FORCE_REQUESTED = 'UPDATE_PRODUCT_SOLD_FORCE_REQUESTED';
export const UPDATE_PRODUCT_SOLD_FORCE_SUCCESSED = 'UPDATE_PRODUCT_SOLD_FORCE_SUCCESSED';

export const PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED = 'PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED';
export const PRODUCT_EDIT_PAGE_DELETE_IMAGE_SUCCESSED = 'PRODUCT_EDIT_PAGE_DELETE_IMAGE_SUCCESSED';

